angular
    .module('festzelt-os.guestlists')
    .factory('createDocumentForRsvps', [
            'DocumentCreateService',
            (DocumentCreateService) => new CreateDocumentForRsvps(DocumentCreateService)
        ]
    );

class CreateDocumentForRsvps {
    constructor(DocumentCreateService) {
        this.documentCreateService = DocumentCreateService;

        this.key = 'create-document-for-rsvps';
        this.title = 'Create document';
        this.level = 'selected';
    }

    action(action, store, newValue) {
        const dataForCreate = {
            ...store.getters.selectedFilters,
            guestlist_id: _.get(store.state, 'vm.guestlist.id', null)
        };

        this.documentCreateService.startNewDocumentWizard('rsvps', store, dataForCreate);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/create-document-for-rsvps.js